(function ($) {
	'use strict'
	Drupal.behaviors.stickyBottom = {
	  attach: function (context, settings) {
	  
		const stickBanner = document.querySelector('.field-add-sticky-bottom-banner .banner__wrapper', context);
		if(stickBanner) {
            // debugger
			const myScrollFunc = () => {
				const y = window.scrollY;
				if (y >= 40) {
					stickBanner.classList = 'field-add-sticky-bottom-banner banner__wrapper show-banner';
				} else {
					stickBanner.className = 'field-add-sticky-bottom-banner banner__wrapper hide-banner';
				}
			};
			window.addEventListener('scroll', myScrollFunc);
		}
	  }
	};
  
}) (jQuery)